var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4884E8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.395.901c-1.164-1.298-3.369-1.159-4.674.194l-21.03 21.342L5.597 11.755C3.952 10.043 2.523 9.58.952 10.937c-1.571 1.357-.993 3.39.26 4.796l12.149 13.62c.637.714 1.483 1.074 2.33 1.074.806 0 1.61-.325 2.24-.975L41.037 5.527c1.303-1.35 1.522-3.328.359-4.626z",
    transform: "translate(-496.000000, -294.000000) translate(464.000000, 188.000000) translate(32.000000, 98.000000) translate(0.000000, 8.000000) translate(6.906544, 11.835925)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.05150de8.svg";
export { ForwardRef as ReactComponent };